import getLabelsOneDayRequest from "./requests/get-labels-one-day-request";
import getMonthCirclesRequest from "./requests/get-month-circles-request";
import getForWeekdayModeRequest from "./requests/get-for-weekday-mode-request";
import getLabelsByStaffListRequest from "./requests/get-labels-by-staff-list-request";
import getIntervalsByDateRequest from "./requests/get-intervals-by-date-request";
import getForEmploymentTableRequest from "./requests/get-for-employment-table-request";
import printLabelsRequest from "./requests/print-labels-request";
import getGroupParticipantsRequest from "./requests/get-group-participants-request";
import getIntervalsByDaycountRequest from "./requests/get-intervals-by-daycount-request";
import printGroupClientsRequest from "./requests/print-group-clients-request";

const journalRepository = {
    getLabelsOneDay: getLabelsOneDayRequest,
    getMonthCircles: getMonthCirclesRequest,
    getForWeekdayMode: getForWeekdayModeRequest,
    getLabelsByStaffList: getLabelsByStaffListRequest,
    getIntervalsByDate: getIntervalsByDateRequest,
    getForEmploymentTable: getForEmploymentTableRequest,
    printLabels: printLabelsRequest,
    getGroupParticipants: getGroupParticipantsRequest,
    getIntervalsByDaycount: getIntervalsByDaycountRequest,
    printGroupClients: printGroupClientsRequest,
};

export default journalRepository;
